// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2283) return "static/chunks/2283-84f73e88a11e04a3.js";
	if (chunkId === 9747) return "static/chunks/9747-185944afe52ecd41.js";
	if (chunkId === 1345) return "static/chunks/1345-00640f59f5caf064.js";
	if (chunkId === 6708) return "static/chunks/6708-613159dbde2526ec.js";
	if (chunkId === 7883) return "static/chunks/7883-53a34ff040852b3b.js";
	if (chunkId === 5050) return "static/chunks/5050-5b511d2e76575c6c.js";
	if (chunkId === 1223) return "static/chunks/1223-001c59959692e093.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"654":"bde972df82f2b969","2649":"0003873662c0e796","2737":"8f072ba0337c075e","3773":"4d9595564ddfdb86","5025":"ff8607e85f2249c6","7029":"a02c4edcbf80657c","9420":"157141f3a9e56bad","9612":"42a55792e8aa2f2d"}[chunkId] + ".js";
};